/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconStar(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8 .355a.75.75 0 0 1 .696.47l1.812 4.493 4.79.306a.75.75 0 0 1 .43 1.326l-3.582 2.963 1.067 4.82a.75.75 0 0 1-1.139.792L8 12.895l-4.074 2.63a.75.75 0 0 1-1.139-.792l1.067-4.82L.272 6.95a.75.75 0 0 1 .43-1.326l4.79-.306L7.304.825A.75.75 0 0 1 8 .355zm0 2.756L6.707 6.316a.75.75 0 0 1-.648.468L2.686 7l2.478 2.05a.75.75 0 0 1 .254.74l-.772 3.485 2.947-1.902a.75.75 0 0 1 .814 0l2.947 1.902-.772-3.485a.75.75 0 0 1 .254-.74L13.314 7l-3.373-.215a.75.75 0 0 1-.648-.468L8 3.11z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M12 .06a1 1 0 0 1 .927.626l2.765 6.856 7.309.466a1 1 0 0 1 .573 1.769l-5.466 4.521 1.628 7.35a1 1 0 0 1-1.519 1.056L12 18.69l-6.217 4.014a1 1 0 0 1-1.519-1.057l1.627-7.349L.425 9.777A1 1 0 0 1 1 8.008l7.309-.466L11.073.686A1 1 0 0 1 12 .06zm0 3.674-2.073 5.14a1 1 0 0 1-.863.624l-5.42.346 3.993 3.303a1 1 0 0 1 .34.986l-1.234 5.57 4.715-3.043a1 1 0 0 1 1.084 0l4.715 3.043-1.233-5.57a1 1 0 0 1 .339-.986l3.993-3.303-5.42-.346a1 1 0 0 1-.864-.624L12 3.734z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconStar is deprecated and will be archived soon. Use IconStar instead.
 */
export function Experimental__IconStar(props) {
  return /*#__PURE__*/React.createElement(IconStar, props);
}